import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Myths',
  name: 'myths',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      initialValue: 'Industry myths',
    }),
    defineField({
      title: 'Myths',
      name: 'myths',
      type: 'array',
      of: [{ type: 'myth' }],
    }),
  ],
})